module.exports = __webpack_public_path__ + "img/alexis-nihon.aa3dba8a.png";